export default "__VITE_ASSET___gXc4UtY__"